import { CreateNewFtpData } from 'components/ftpConfigurations/newFtpGenerationForm'
import Api from './axiosInstance'
import { API_FTP_CONFIGURATION } from 'utils/constants'
const { FTP_CONFIGURATION, STORE } = API_FTP_CONFIGURATION

type CommonParams = {
  limit: number
  page: number
}

type UpdateFtpConfigurationsParams = {
  ftpConfigId: string
  data: {
    aggregators: Array<{
      aggregator: string
    }>
  }
}

// get all FTP Configurations
const fetchFtpConfigurations = ({ limit, page }: CommonParams) => {
  return Api.get({
    url: `${FTP_CONFIGURATION}?limit=${limit}&page=${page}`,
  })
}

// Create New FTP Configurations for selected stores and aggregators
const createFtpConfigurations = (data: CreateNewFtpData) => {
  return Api.post({ url: FTP_CONFIGURATION, data })
}

// updates the aggregators of FTP configuration for store
const updateFtpConfigurations = ({
  ftpConfigId,
  data,
}: UpdateFtpConfigurationsParams) => {
  return Api.patch({ url: `${FTP_CONFIGURATION}/${ftpConfigId}`, data })
}

// get the stores which are not configured in FTP
const fetchStoresNotInFtp = () => {
  return Api.get({
    url: STORE,
  })
}

export {
  fetchFtpConfigurations,
  createFtpConfigurations,
  updateFtpConfigurations,
  fetchStoresNotInFtp,
}
